import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { Helmet } from "react-helmet";

import { boardUrl } from "../urls";
import { Army } from "../board/GameState";
import { GameState, LocalGame, ArmyForm } from "../board";

type Props = RouteComponentProps<{ epd: string }>;

const decodeEpd = (encoded: string) => decodeURI(encoded).replace(/_/g, " ");

type State = {
  whiteArmy: Army | null;
  blackArmy: Army | null;
  epd: string | null;
  // When LocalGame is showing an EPD but the URL hasn't yet been updated,
  // nextEpd stores the shown EPD and epd stores the URL EPD.
  nextEpd: string | null;
  localGameKey: number;
};

export default class BoardPage extends React.Component<Props, State> {
  static getDerivedStateFromProps(props: Props, state: State) {
    const newState: Partial<State> = {};
    // When the URL updates, we need to update the LocalGame's key so that it
    // renders the updated game instead. However, we need to make sure not to
    // update the key when the URL is actually the currently reflected game, as
    // dong so would cancel and transitions in progress.
    const epd = props.match.params.epd
      ? decodeEpd(props.match.params.epd)
      : null;
    if (epd === state.nextEpd) {
      newState.nextEpd = null;
      newState.epd = state.nextEpd;
    } else if (epd !== state.epd) {
      state.epd = epd;
      state.nextEpd = null;
      newState.localGameKey = state.localGameKey + 1;
    }
    return newState;
  }

  constructor(props: Props) {
    super(props);
    this.state = {
      whiteArmy: null,
      blackArmy: null,
      epd: props.match.params.epd ? decodeEpd(props.match.params.epd) : null,
      nextEpd: null,
      localGameKey: 1,
    };
  }

  parseEpd(encoded: string) {
    const epd = decodeURI(encoded).replace(/_/g, " ");
    if (this.state.epd !== epd) {
      this.setState({ epd });
    }
  }

  handleChooseArmy = (color: string, army: Army) => {
    if (color === "white") {
      this.setState({ whiteArmy: army });
    } else {
      this.setState({ blackArmy: army });
    }
  };

  handleGameChange = (game: GameState) => {
    if (this.state.epd !== game.epd) {
      this.setState({ nextEpd: game.epd });
      const nextEpd = encodeURI(game.epd.replace(/ /g, "_"));
      this.props.history.push(boardUrl(nextEpd));
    }
  };

  render() {
    let content = this.state.epd ? (
      <LocalGame
        key={this.state.localGameKey}
        epd={this.state.epd}
        onGameChange={this.handleGameChange}
      />
    ) : this.state.whiteArmy && this.state.blackArmy ? (
      <LocalGame
        key={this.state.localGameKey}
        armies={[this.state.whiteArmy, this.state.blackArmy]}
        onGameChange={this.handleGameChange}
      />
    ) : this.state.whiteArmy ? (
      <>
        <h1>Create local game</h1>
        <ArmyForm
          key="black"
          color="black"
          onSubmit={(a) => this.handleChooseArmy("black", a)}
        />
      </>
    ) : (
      <>
        <h1>Create local game</h1>
        <ArmyForm
          key="white"
          color="white"
          onSubmit={(a) => this.handleChooseArmy("white", a)}
        />
      </>
    );
    return (
      <div>
        <Helmet title="Local Game" />
        {content}
      </div>
    );
  }
}
